/** Reconnect-Backoff nach Doc 04 §2.4: 0,5 / 1 / 2 / 4 / 5 s (danach 5 s). */
export const RECONNECT_SCHEDULE_MS = [500, 1000, 2000, 4000, 5000] as const;

export function backoffDelay(attempt: number): number {
  const i = Math.max(0, Math.min(attempt, RECONNECT_SCHEDULE_MS.length - 1));
  return RECONNECT_SCHEDULE_MS[i] as number;
}

/** Fehlercodes, bei denen ein Reconnect sinnlos ist. */
export const FATAL_ERROR_CODES = new Set(['auth_failed', 'bad_config', 'revoked', 'engine_unavailable', 'forbidden', 'not_found']);

/** WebSocket-Close-Codes des Gateways, die keinen Reconnect auslösen. */
export const FATAL_CLOSE_CODES = new Set([4400, 4401, 4403, 4404, 4409, 4503]);
